module.exports = __webpack_public_path__ + "media/images/illustrations/bg-shop-c8ca6a1c16292a0e38f79aab7bcbf931.png";